import React, { useState, useEffect } from "react";
import "./App.css";
import RegistrationForm from "./components/RegistrationForm";
import AddJudgePage from "./pages/AddJudge";
import ParticipantPage from "./pages/ParticipantPage";
import JudgePage from "./pages/JudgePage";
import ParticipantForm from "./pages/PartcipantForm";
import ParticipantProfilePage from "./pages/ParticipantProfilePage";
import RoundscoresPage from "./pages/RoundscoresPage";
import JudgeHome from "./pages/JudgeHome";
import VideoSubmissionPage from "./pages/VideoForm";
import OverviewPage from "./pages/OverviewPage";
import EvaluateSubmission from "./pages/EvaluateSubmission";
import NotificationsPage from "./pages/notificationsPage";
import ResetPasswordPage from "./pages/ResetPassword";
import ProgramHomePageRedirect from "./components/HomePageRedirect";
import HomePage from "./pages/Homepage";
import UsersPage from "./pages/UsersPage";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import {
  Layout,
  Menu,
  Select,
  Modal,
  Form,
  Input,
  Button,
  message,
  Space,
} from "antd";
import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
  HomeOutlined,
  SettingOutlined,
  GlobalOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  BarChartOutlined,
  EditOutlined,
  FormOutlined,
  BellOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import NumberIcon from "./components/NumberIcon";
import Item from "antd/es/list/Item";
import SignUpSignInPage from "./pages/SignUpIn";
import Cookies from "js-cookie";
import axios from "axios";
import { sha256 } from "hash.js";
import FormBuilderPage from "./pages/FormBuilderPage";
import { firebaseAPI } from "./firebaseConfig";
import Logo from "./components/Logo";
import AppHeader from "./components/HeaderComponent";
import axiosInstance from "./utils/axiosInstance";

// Function to hash a string using SHA-256
function hashString(input) {
  return sha256().update(input).digest("hex");
}

const { Header, Content, Footer, Sider } = Layout;
const { Option } = Select;

function getItem(label, key, icon, children, onClick, collapsed) {
  return {
    key: key,
    icon: icon,
    children: children,
    label: collapsed ? null : label,
    onClick: onClick, // Add onClick handler to the item
  };
}

function App() {
  const location = useLocation(); // Hook to get current location
  const signUpAllowed = false;
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState(
    sessionStorage.getItem("selectedKey") || "1"
  );
  const [isLoggedIn, setIsLoggedIn] = useState(
    Cookies.get("token") ? true : false
  );
  const [fixedRole, setFixedRole] = useState(Cookies.get("role"));
  const [programs, setPrograms] = useState([]);
  const [programName, setProgramName] = useState(
    location.pathname.split("/").length > 2
      ? location.pathname.split("/")[1]
      : programs[0]
      ? programs[0]
      : "SummerAcademy2025"
  );
  const [programRounds, setProgramRounds] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [isHomePageModalVisible, setIsHomePageModalVisible] = useState(false);
  const [homePageUrl, setHomePageUrl] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch program rounds when the component mounts or when location changes
    fetchPrograms();
    fetchProgramRounds();
    // fetchProgramHomePage();
    ////console.log(location.pathname.split('/'));
    const programName =
      location.pathname.split("/").length > 2
        ? location.pathname.split("/")[1]
        : programs[0]
        ? programs[0]
        : "SummerAcademy2025";
    setProgramName(programName);
  }, [location.pathname]);

  const fetchProgramRounds = async () => {
    try {
      // Extract program name from URL
      const programName = location.pathname.split("/")[1];

      // Fetch program rounds from backend
      const response = await axiosInstance.get(
        `${firebaseAPI}/program/${programName}/rounds`
      );
      const { programRounds } = response.data;

      // Set program rounds
      setProgramRounds(programRounds);
    } catch (error) {
      console.error("Error fetching program rounds:", error);
    }
  };

  const fetchPrograms = async () => {
    try {
      const response = await axiosInstance.get(`${firebaseAPI}/programs`);
      setPrograms(response.data);
      ////console.log(response.data)
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  const fetchProgramHomePage = async () => {
    try {
      const programName = location.pathname.split("/")[1];
      const response = await axiosInstance.get(
        `${firebaseAPI}/program/${programName}/getProgramHomePage`
      );
      if (response.data) setHomePageUrl(response.data.programHomePageUrl);
      ////console.log(response.data)
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  const handleProgramChange = async (value) => {
    if (value === "addNew") {
      setIsModalVisible(true);
    } else {
      window.location.href = `/${value}/overview`;
      setProgramName(value);
      // Fetch new program rounds based on the selected program
      try {
        const response = await axiosInstance.get(
          `${firebaseAPI}/program/${value}/rounds`
        );
        const { programRounds } = response.data;
        setProgramRounds(programRounds);
      } catch (error) {
        console.error("Error fetching program rounds:", error);
      }
    }
  };

  const handleAddProgram = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = async (values) => {
    // Extract programRounds from values and map them to an array of strings
    const programRounds = values.programRounds.map((round) => round.round);
    ////console.log(programRounds)

    // Remove programRounds from values
    const { programName, ...rest } = values;

    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.post(
        `${firebaseAPI}/program`,
        {
          programName,
          programRounds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      ////console.log(response.data);
      setIsModalVisible(false);
      fetchPrograms();
    } catch (error) {
      console.error("Error adding program:", error);
    }
  };

  useEffect(() => {
    const token = Cookies.get("token");
    const tokenExpiration = Cookies.get("tokenExpiration");

    if (token && tokenExpiration) {
      const expirationTime = new Date(tokenExpiration);
      if (expirationTime <= new Date()) {
        // Token is expired
        setIsLoggedIn(false);
        setFixedRole("");
        Cookies.remove("role");
        Cookies.remove("token");
        Cookies.remove("tokenExpiration");
      }
    } else {
      // No token found
      setIsLoggedIn(false);
      setFixedRole("");
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("selectedKey", selectedKey);
  }, [selectedKey, isLoggedIn]);

  const showHomePageModal = () => {
    setIsHomePageModalVisible(true);
  };

  const handleHomePageOk = async () => {
    setLoading(true);
    try {
      let token = Cookies.get("token") || "";

      const response = await axiosInstance.post(
        `${firebaseAPI}/program/addHomePage`,
        {
          programName,
          programHomePageUrl: homePageUrl,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        message.success(response.data.message);
      } else {
        message.error(response.data.error);
      }
    } catch (error) {
      message.error("An error occurred while adding the home page URL.");
    } finally {
      setLoading(false);
      setIsHomePageModalVisible(false);
    }
  };

  const handleHomePageCancel = () => {
    setIsHomePageModalVisible(false);
  };
  const items1 = [
    getItem(
      <Space
        onClick={() => {
          setSelectedKey("1");
          window.location.href = `/${programName}/overview`;
        }}
      >
        <PieChartOutlined />
        Overview
      </Space>,
      "1"
    ),
    getItem(
      <Space
        onClick={() => {
          setSelectedKey("3");
          window.location.href = `/${programName}/users`;
        }}
      >
        <UserOutlined />
        Users
      </Space>,
      "3"
    ),
    getItem(
      <Space
        onClick={() => {
          setSelectedKey("4");
          window.location.href = `/${programName}/judges`;
        }}
      >
        <TeamOutlined />
        Judges
      </Space>,
      "4"
    ),
    getItem(
      <Space
        onClick={() => {
          setSelectedKey("5");
          window.location.href = `/${programName}/notifications`;
        }}
      >
        <BellOutlined />
        Notifications
      </Space>,
      "5"
    ),
  ];

  const items2 = programRounds.map((round, index) =>
    getItem(round, `sub${index + 1}`, <OrderedListOutlined />, [
      getItem(
        <Space
          onClick={() => {
            setSelectedKey(`${index * 6 + 6}`);
            window.location.href = `/${programName}/participantform/${round}`;
          }}
        >
          <FormOutlined />
          Round Form
        </Space>,
        `${index * 6 + 6}`
      ),
      getItem(
        <Space
          onClick={() => {
            setSelectedKey(`${index * 6 + 7}`);
            window.location.href = `/${programName}/formbuilder/${round}`;
          }}
        >
          <EditOutlined />
          Form Builder
        </Space>,
        `${index * 6 + 7}`
      ),
      getItem(
        <Space
          onClick={() => {
            setSelectedKey(`${index * 6 + 10}`);
            window.location.href = `/${programName}/roundscores/${round}`;
          }}
        >
          <BarChartOutlined />
          Round Scores
        </Space>,
        `${index * 6 + 10}`
      ),
      {
        label: (
          <Space onClick={() => handleRemoveRound(round)}>
            <DeleteOutlined />
            Remove Round
          </Space>
        ),
        key: `${index * 6 + 11}`,
      },
    ])
  );

  const [newRound, setNewRound] = useState("");
  const [roundToRemove, setRoundToRemove] = useState("");

  const handleAddRound = async () => {
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.post(
        `${firebaseAPI}/program/addRound`,
        { newRound, programName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      message.success(response.data.message);
      setNewRound("");
      fetchProgramRounds();
    } catch (error) {
      message.error("Failed to add round");
    }
  };

  const handleRemoveRound = async (round) => {
    try {
      let token = Cookies.get("token") || "";
      Modal.confirm({
        title: "Confirm",
        content: "Are you sure you want to remove this round?",
        onOk: async () => {
          const response = await axiosInstance.post(
            `${firebaseAPI}/program/removeRound`,
            { roundToRemove: round, programName },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          message.success(response.data.message);
          fetchProgramRounds();
        },
        onCancel() {
          // Do nothing if user cancels
        },
      });
    } catch (error) {
      message.error("Failed to remove round");
    }
  };

  const handleLogout = () => {
    // Remove token from sessionStorage to sign out
    Cookies.remove("token");
    Cookies.remove("role");
    // Redirect or perform any other action after sign out
    window.location.href = `/${programName}/sign-in`;
  };

  const handleCopyLink = () => {
    // Get the current URL
    const currentUrl = window.location.href;
    // Extract the base URL and program name
    const baseUrl = currentUrl.split("/").slice(0, 3).join("/");
    // Create the shareable link
    const shareableLink = `${baseUrl}/${programName}/sign-in`;

    // Copy the link to the clipboard
    navigator.clipboard
      .writeText(shareableLink)
      .then(() => {
        message.success("Shareable link copied to clipboard");
      })
      .catch((err) => {
        message.error("Failed to copy the link");
        console.error("Failed to copy the link:", err);
      });
  };

  return (
    <div className="App">
      <Layout style={{ height: "100vh" }}>
        <AppHeader
          isLoggedIn={isLoggedIn}
          programName={programName}
          handleLogout={handleLogout}
        />
        <Layout style={{ maxHeight: "100%", backgroundColor: "#f0f2f5" }}>
          {fixedRole === hashString("admin") && (
            <Sider
              collapsible
              collapsed={collapsed}
              onCollapse={(value) => setCollapsed(value)}
              theme="light" // Set sidebar theme to light
              style={{ overflowY: "auto", padding: "8px 4px" }}
            >
              <Select
                value={decodeURI(programName)}
                style={{ width: "100%", marginBottom: "20px" }}
                onChange={handleProgramChange}
              >
                {programs.map((program) => (
                  <Option key={program} value={program}>
                    {program}
                  </Option>
                ))}
                <Option value="addNew">
                  Add New Program <PlusCircleOutlined />
                </Option>
                {/* Option to add new program */}
              </Select>

              {/* Modal for adding new program */}
              <Modal
                title="Add New Program"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
              >
                <Form form={form} onFinish={onFinish}>
                  <Form.Item
                    label="Program Name"
                    name="programName"
                    rules={[
                      { required: true, message: "Please enter program name" },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  {/* Dynamic input fields for Program Rounds */}
                  <Form.List name="programRounds">
                    {(fields, { add, remove }) => (
                      <div>
                        {fields.map((field, index) => (
                          <div key={field.key}>
                            <Form.Item
                              {...field}
                              label={`Program Round ${index + 1}`}
                              name={[field.name, "round"]}
                              fieldKey={[field.fieldKey, "round"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter program round",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                            {fields.length > 1 ? (
                              <Button
                                type="danger"
                                onClick={() => remove(field.name)}
                              >
                                <MinusCircleOutlined />
                              </Button>
                            ) : null}
                          </div>
                        ))}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            style={{ width: "100%" }}
                          >
                            Add Program Round <PlusCircleOutlined />
                          </Button>
                        </Form.Item>
                      </div>
                    )}
                  </Form.List>

                  {/* <Form.Item label="Registration Deadline" name="registraionDeadline">
              <Input />
            </Form.Item>
            <Form.Item label="Marketing Paragraph" name="marketingParagraph">
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="About" name="about">
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="Profile Needed" name="profileNeeded">
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="Program Timeline" name="programTimeline">
              <Input.TextArea />
            </Form.Item>

            <Form.Item label="FAQ" name="FAQ">
              <Input.TextArea />
            </Form.Item> */}

                  {/* Submit Button */}
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Add Program
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
              <Menu
                selectedKeys={[selectedKey]}
                mode="inline"
                style={{ textAlign: "left", border: "none" }}
                items={items1.map((item) =>
                  getItem(
                    item.label,
                    item.key,
                    item.icon,
                    item.children,
                    item.onClick,
                    collapsed
                  )
                )}
              />
              {/* Home Page URL Modal */}
              <Modal
                title="Set Home Page URL"
                visible={isHomePageModalVisible}
                onOk={handleHomePageOk}
                onCancel={handleHomePageCancel}
                confirmLoading={loading}
              >
                <Form>
                  <Form.Item
                    label="Home Page URL"
                    name="homePageUrl"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the home page URL",
                      },
                    ]}
                  >
                    <Input
                      defaultValue={homePageUrl}
                      value={homePageUrl}
                      onChange={(e) => setHomePageUrl(e.target.value)}
                    />
                  </Form.Item>
                </Form>
              </Modal>
              <Button
                type="primary"
                onClick={handleCopyLink}
                style={{ margin: "8px 0" }}
              >
                Copy Shareable Link
              </Button>
              <Button
                type="text"
                disabled
                style={{
                  margin: "8px 0",
                  textAlign: "left",
                  width: "100%",
                  paddingInline: "24px",
                }}
              >
                Program Rounds
              </Button>
              <Menu
                selectedKeys={[selectedKey]}
                mode="inline"
                style={{ textAlign: "left", border: "none" }}
                items={items2.map((item) =>
                  getItem(
                    item.label,
                    item.key,
                    item.icon,
                    item.children,
                    item.onClick,
                    collapsed
                  )
                )}
              ></Menu>
              <div style={{ margin: "8px 12px", display: "flex" }}>
                <Input
                  value={newRound}
                  onChange={(e) => setNewRound(e.target.value)}
                  placeholder="Enter Round Name"
                />
              </div>
              <Button onClick={handleAddRound}>
                <PlusCircleOutlined />
              </Button>
            </Sider>
          )}
          <Content style={{ margin: "16px 24px" }}>
            <Routes>
              {/* <Route path="/:programName" element={<Navigate to={`/${programName}/sign-in`}/>} /> */}
              <Route
                path="/:programName/sign-in"
                element={
                  isLoggedIn && programName ? (
                    fixedRole === hashString("admin") ? (
                      <Navigate to={`/${programName}/overview`} />
                    ) : fixedRole === hashString("judge") ? (
                      <Navigate to={`/${programName}/judgehome`} />
                    ) : (
                      <Navigate to={`/${programName}/participantprofile`} />
                    )
                  ) : (
                    <SignUpSignInPage />
                  )
                }
              />
              <Route path="/resetpassword" element={<ResetPasswordPage />} />
              <Route
                path="/:programName"
                element={<HomePage isLoggedIn={isLoggedIn} />}
              />
              <Route
                path="/registration"
                element={
                  isLoggedIn ? (
                    <RegistrationForm />
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/addjudge"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <AddJudgePage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/participants/:formName"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <ParticipantPage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/judges"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <JudgePage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/participantform/:formName"
                element={
                  isLoggedIn ? (
                    <ParticipantForm />
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/roundscores/:formName"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <RoundscoresPage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/videosubmission"
                element={
                  isLoggedIn ? (
                    <VideoSubmissionPage />
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/evaluatesubmission/:submissionId"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("judge") ||
                    fixedRole === hashString("admin") ? (
                      <EvaluateSubmission />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/judgehome"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("judge") ? (
                      <JudgeHome />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/participantprofile"
                element={
                  isLoggedIn ? (
                    <ParticipantProfilePage signUpAllowed={signUpAllowed} />
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/users"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <UsersPage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/overview"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <OverviewPage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/notifications"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <NotificationsPage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route
                path="/:programName/formbuilder/:formName"
                element={
                  isLoggedIn ? (
                    fixedRole === hashString("admin") ? (
                      <FormBuilderPage />
                    ) : (
                      <Navigate to={`/${programName}`} />
                    )
                  ) : (
                    <Navigate to={`/${programName}/sign-in`} />
                  )
                }
              />
              <Route path="*" element={<Navigate to={`/${programName}`} />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default App;
